export function getLocationDisplayName(location) {
  if (!location) return '';
  if (typeof location === 'string') return location;

  const displayName = typeof location.displayName === 'string'
    ? location.displayName.trim()
    : '';

  return displayName || location.name || '';
}

export function cleanLocationDisplayName(location) {
  return getLocationDisplayName(location)
    .replace(/Preuniversitario\s*/gi, '')
    .replace(/Pre Sede\s*/gi, '')
    .replace(/Pre Norte\s*/gi, '')
    .trim();
}
